import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const SantaCruzTheme = definePreset(Aura, {
	semantic: {
		primary: {
			50: '#eff4fa',
			100: '#c7d9ea',
			200: '#9bb8d3',
			300: '#6fa0c4',
			400: '#4387b5',
			500: '#0f4f94', // Primary color
			600: '#0d4685',
			700: '#0b3d76',
			800: '#093467',
			900: '#072b58',
			950: '#052249',
		},
	},
	components: {
		confirmdialog: {
			icon: {
				size: '1.5rem',
				color: '#0f4f94',
			},
			content: {
				gap: '1rem',
			},
		},
		tooltip: {
			root: {
				maxWidth: '20rem',
				gutter: '0.375rem',
				padding: '0.625rem 0.75rem',
				borderRadius: '0.5rem',
				shadow: '0 8px 24px rgba(12, 62, 116, 0.22)',
			},
			colorScheme: {
				light: {
					root: {
						background: '#1F1F38',
						color: '#ffffff',
					},
				},
				dark: {
					root: {
						background: '#eff4fa',
						color: '#1F1F38',
					},
				},
			},
		},
		message: {
			colorScheme: {
				light: {
					warn: {
						background: '#fff3e8',
						borderColor: '#9c4900',
						color: '#9c4900',
						outlined: {
							color: '#9c4900',
							borderColor: '#9c4900',
						},
						simple: {
							color: '#9c4900',
						},
					},
				},
				dark: {
					warn: {
						background: 'color-mix(in srgb, #f5811b, transparent 80%)',
						borderColor: '#f9b376',
						color: '#ffe5cc',
						outlined: {
							color: '#ffe5cc',
							borderColor: '#f9b376',
						},
						simple: {
							color: '#ffe5cc',
						},
					},
				},
			},
		},
		progressspinner: {
			colorScheme: {
				light: {
					root: {
						colorOne: '#0f4f94',
						colorFour: '#0f4f94',
						colorThree: '#0f4f94',
						colorTwo: '#0f4f94',
					},
				},
			},
		},
		selectbutton: {},
		button: {
			colorScheme: {
				light: {
					text: {
						primary: {
							color: '#0f4f94',
							hoverBackground: '#c7d9ea',
							activeBackground: 'transparent',
						},
						danger: {
							color: '{red.700}',
							hoverBackground: '{red.50}',
							activeBackground: '{red.100}',
						},
					},
					root: {
						success: {
							color: '#ffffff',
							background: '#198754',
							borderColor: '#198754',
							hoverBackground: '#146c43',
							hoverBorderColor: '#146c43',
							hoverColor: '#ffffff',
							activeBackground: '#0f5132',
							activeBorderColor: '#0f5132',
							activeColor: '#ffffff',
						},
						contrast: {
							color: '#ffffff',
							background: '#3b3a48',
							borderColor: '#3b3a48',
							hoverBackground: '#5e5e6a',
							hoverBorderColor: '#5e5e6a',
							hoverColor: '#ffffff',
							activeBackground: '#4a4958',
							activeBorderColor: '#4a4958',
							activeColor: '#ffffff',
						},
						help: {
							color: '#ffffff',
							background: '#034B6B',
							borderColor: '#034B6B',
							hoverBackground: '#0C3E74',
							hoverBorderColor: '#0C3E74',
							hoverColor: '#ffffff',
							activeBackground: '#0C3E74',
							activeBorderColor: '#0C3E74',
							activeColor: '#ffffff',
						},
						danger: {
							color: '#ffffff',
							background: '#dc3545',
							borderColor: '#dc3545',
							hoverBackground: '{red.700}',
							hoverBorderColor: '{red.700}',
							hoverColor: '#ffffff',
							activeBackground: '{red.800}',
							activeBorderColor: '{red.800}',
							activeColor: '#ffffff',
						},
						secondary: {
							color: '5E5E6A',
							background: '#FAFAFA',
							borderColor: '#5E5E6A',
							hoverBackground: '#FFFFFF',
							hoverBorderColor: '#000000',
							hoverColor: '#034B6B',
							activeBackground: '#FFFFFF',
							activeBorderColor: '#000000',
							activeColor: '#000000',
						},
						primary: {
							color: 'white',
							background: '#0f4f94',
							borderColor: '#0f4f94',
							hoverBackground: '#0C3E74',
							hoverBorderColor: '#0f4f94',
							activeBackground: '#0f4f94',
							activeBorderColor: '#0f4f94',
						},
						warn: {
							color: 'black',
							background: '#f5811b',
							borderColor: '#f5811b',
							hoverBackground: '#F9B376',
							hoverBorderColor: '#F9B376',
							hoverColor: '#3B3A48',
							activeBackground: '#f5811b',
							activeBorderColor: '#f5811b',
							activeColor: 'black',
						},
						info: {
							color: 'white',
							background: '#2c2c4f',
							borderColor: '#2c2c4f',
							hoverBackground: '#1F1F38',
							hoverBorderColor: '#1F1F38',
							hoverColor: 'white',
							activeBackground: '#2c2c4f',
							activeBorderColor: '#2c2c4f',
							activeColor: 'white',
						},
					},
					outlined: {
						success: {
							color: '#146c43',
							borderColor: '#198754',
							hoverBackground: '#e8f3ed',
							activeBackground: '#d1e7dd',
						},
						info: {
							color: '#2c2c4f',
							borderColor: '#2c2c4f',
							hoverBackground: '#eff4fa',
							activeBackground: '#c7d9ea',
						},
						warn: {
							color: '#9c4900',
							borderColor: '#9c4900',
							hoverBackground: '#fff3e8',
							activeBackground: '#ffe5cc',
						},
						danger: {
							color: '#b02a37',
							borderColor: '#dc3545',
							hoverBackground: '#fbeaec',
							activeBackground: '#f8d7da',
						},
						help: {
							color: '#034B6B',
							borderColor: '#034B6B',
							hoverBackground: '#eff4fa',
							activeBackground: '#c7d9ea',
						},
					},
				},
				dark: {},
			},
		},
	},
});
